module.exports = __webpack_public_path__ + "static/media/wavy_left.8a001e4e.svg";